module.exports = __webpack_public_path__ + "static/media/5DPO5.c40640e5.jpg";